import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {BlockElementLabelComponent} from 'app/components/blocks/components/blockElementLabel/item';

@NgModule({
  imports: [
    IonicModule,
    CommonModule
  ],
  exports: [
    BlockElementLabelComponent
  ],
  declarations: [
    BlockElementLabelComponent
  ],
  providers: [],
})
export class BlockElementLabelComponentModule {

}
